export default (defaultLanguage = 'en', languages = {}, values = {}) => ({
    selectedLanguage: defaultLanguage,
    selectedLanguageLabel: '',
    selectedValue: '–',
    languages: languages,
    values: values,
    init() {
        this.$watch('selectedLanguage', () => {
            this.selectedLanguageLabel = this.getSelectedLanguageLabel();
            this.selectedValue = this.getSelectedValue();
        });

        this.selectedLanguageLabel = this.getSelectedLanguageLabel();
        this.selectedValue = this.getSelectedValue();
    },
    changeTo(language) {
        this.selectedLanguage = language;

        this.$dispatch('language-changed', {language: language});
    },
    getSelectedLanguageLabel() {
        return this.languages[this.selectedLanguage] || this.selectedLanguage;
    },
    getSelectedValue() {
        return this.values[this.selectedLanguage] || '–';
    },
    handleChangedLanguage(event) {
        this.selectedLanguage = event.detail.language;
    }
});
